/*
 * 列表页 B 版产品卡：「主标题 + 副标题」整块按行对齐
 * 需求：需求/20260917-产品卡标签与活动体系/（用户 2026-09-28 调整）
 *
 * 目标：同一行里
 *   - 主标题与副标题作为**一个整体**（副标题紧跟主标题，自身不再单独等高）；
 *   - 整块高度取本行最大值 ⇒ 其下的**评分星星**从同一条水平线开始；
 *   - 星星与整块的最小间距由 `.vl-product-card__head` 的 gap 保证（8px）。
 *   - 2026-09-29 追加：**活动信息条槽位**同样按行预留 —— 本行「有信息条」的卡片多高，
 *     本行所有卡片的槽位就预留多高（⇒ 同行标题对齐）；整行都没有信息条则预留 0（不占位）。
 *
 * 为什么需要 JS（纯 CSS 无解）：
 *   整块高度可能大于本行的自然行高（例：A 卡标题 2 行＋副标题 1 行＝3 行；B 卡标题 1 行＋副标题 1 行＝2 行
 *   ⇒ 整块都取 3 行的高度，而本行自然高度只有 3 行里的最高者）。
 *   CSS 无法按行测量、也无法选择"同一行的兄弟卡片"，因此这里逐行测量后把整块的最小高度
 *   写成 `--vl-head-text-min`（见 assets/vl-product-card.css），由 `.vl-product-card__head-text` 的
 *   min-height 落实；行高会随之自然增长。
 *
 * 只处理**可见的** `vl-product-card`（新版产品卡）；宽高为 0 或 `visibility:hidden` 的卡片跳过。
 * 触发时机：初始 / 字体就绪（换行点会变）/ 视口或栅格尺寸变化 / 主题编辑器加载 section。
 */
(function () {
  'use strict';

  var ROW_TOLERANCE = 2; /* 判定"同一行"的纵向容差（px） */

  /*
   * 「主标题 + 副标题」整块的**自然高度**（不含 min-height 预留）：
   * 标题盒高（＝行数 × 20px，`.vl-product-card__title` 是 flex:0 0 auto 的块级元素）
   * ＋（有副标题时）容器 row-gap ＋ 副标题盒高（＝行数 × 18px）。
   * 用**元素盒高**而不是 Range 文本高：Range 取的是字体的行盒（含 ascent/descent，比 line-height 高），
   * 会把整块多量出 5px 左右、让星星比设计稿整体下移。
   */
  function blockNaturalHeight(card) {
    var wrapper = card.querySelector('[data-vl-product-card-head-text]');
    if (!wrapper) return 0;
    var title = wrapper.querySelector('.vl-product-card__title');
    var subtitle = wrapper.querySelector('.vl-product-card__subtitle');
    var gap = parseFloat(window.getComputedStyle(wrapper).rowGap) || 0;
    var height = title ? title.getBoundingClientRect().height : 0;
    if (subtitle) height += gap + subtitle.getBoundingClientRect().height;
    return Math.round(height);
  }

  function align() {
    var cards = document.querySelectorAll('vl-product-card[data-vl-product-card]');
    if (!cards.length) return;

    var rows = [];
    Array.prototype.forEach.call(cards, function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return; /* 未显示（无盒）：跳过 */
      /* 占位式隐藏（visibility:hidden）的卡片不显示给用户，
         不应参与"本行最大行数"的计算（也不必为它预留高度）。 */
      if (window.getComputedStyle(card).visibility === 'hidden') return;

      var row = null;
      for (var i = 0; i < rows.length; i += 1) {
        if (Math.abs(rows[i].top - rect.top) <= ROW_TOLERANCE) {
          row = rows[i];
          break;
        }
      }
      if (!row) {
        row = { top: rect.top, cards: [] };
        rows.push(row);
      }
      row.cards.push(card);
    });

    rows.forEach(function (row) {
      var maxBlock = 0;
      var maxPriceBlock = 0;
      /* ⚠️ 必须每行重置：否则第一行有信息条后，后面的行会沿用上一行的 true，永远不清零 */
      var rowHasInfo = false;
      /* 价格块按行等高：先清零，量自然高度（含库存行/无库存的差异），再统一写回 */
      row.cards.forEach(function (card) {
        var pb = card.querySelector('.vl-product-card__price-block');
        if (pb) pb.style.minHeight = '0px';
      });
      row.cards.forEach(function (card) {
        var pb = card.querySelector('.vl-product-card__price-block');
        if (pb) {
          var ph = pb.getBoundingClientRect().height;
          if (ph > maxPriceBlock) maxPriceBlock = ph;
        }
      });
      row.cards.forEach(function (card) {
        var h = blockNaturalHeight(card);
        if (h > maxBlock) maxBlock = h;
        if (card.querySelector('[data-vl-product-card-info]')) rowHasInfo = true;
      });
      row.cards.forEach(function (card) {
        var wrapper = card.querySelector('[data-vl-product-card-head-text]');
        if (wrapper) wrapper.style.setProperty('--vl-head-text-min', maxBlock + 'px');
        var pb = card.querySelector('.vl-product-card__price-block');
        if (pb) {
          pb.style.removeProperty('min-height');
          pb.style.setProperty('--vl-price-block-min', maxPriceBlock + 'px');
        }
        var slot = card.querySelector('[data-vl-product-card-info-slot]');
        if (slot) {
          if (rowHasInfo) slot.style.removeProperty('min-height');
          else slot.style.minHeight = '0';
        }
        /* 旧版按"标题带/副标题带"分别预留的变量已废弃，清掉避免残留 */
        card.style.removeProperty('--vl-title-lines');
        card.style.removeProperty('--vl-subtitle-lines');
      });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      align();
    });
  }

  /* 卡片样式表尚未生效时量出来的行数不可信（会被回退字体/默认字号影响）→ 先不量 */
  function cardCssReady() {
    var link = document.querySelector('link[href*="vl-product-card.css"]');
    return !link || !!link.sheet;
  }

  /*
   * 首屏尽量同步跑一次：本脚本由 sections/products.liquid 在**栅格之后、不加 defer** 加载，
   * 因此执行时栅格内的卡片已在 DOM 中。
   * 但 `vl-product-card.css` 也在 section 里（body 中）输出，此刻可能尚未加载/生效 ——
   * 若未生效就测量会得到错误行数（"先未对齐再跳动"），故：
   *   - 已生效 → 立即同步测量（首屏即对齐）；
   *   - 未生效 → 挂到该样式表的 load 事件上，在下一帧（首次绘制前）补跑。
   */
  var cssLink = document.querySelector('link[href*="vl-product-card.css"]');
  if (document.querySelector('.shop__products-grid vl-product-card')) {
    if (cardCssReady()) {
      align();
    } else if (cssLink) {
      cssLink.addEventListener('load', function () {
        window.requestAnimationFrame(align);
      });
    } else {
      schedule();
    }
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  /* 兜底：整页 load 后再对一次（覆盖样式表/图片带来的行高变化） */
  window.addEventListener('load', schedule);

  /* 字体换完会改变换行点 → 需要重新测量（与 assets/vl-product-card.js 的跑马灯同一考虑） */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', schedule);
  }

  /* 主题编辑器里 section 重新加载 */
  document.addEventListener('shopify:section:load', schedule);

  /* 视口宽度 / 列数变化 */
  window.addEventListener('resize', schedule);

  /*
   * 观察栅格的尺寸变化。注意：集合页筛选/排序会 AJAX 替换 #ShopProducts 的子节点，
   * `.shop__products-grid` 这个节点本身会被换掉 ⇒ 观察者必须重新挂到新节点上，
   * 否则筛选后标题带不再按行对齐（配合 assets/vl-product-card.js 的 cards-updated 事件）。
   */
  var gridObserver = null;
  function observeGrid() {
    if (!window.ResizeObserver) return;
    var grid = document.querySelector('.shop__products-grid');
    if (!grid || (gridObserver && gridObserver.target === grid)) return;
    if (gridObserver) gridObserver.observer.disconnect();
    var observer = new ResizeObserver(schedule);
    observer.observe(grid);
    gridObserver = { target: grid, observer: observer };
  }

  observeGrid();
  document.addEventListener('vl-collection:cards-updated', function () {
    observeGrid();
    schedule();
    /* 替换后布局/图片/字体还会再变一次，补两次延时复量（每次 align 都是幂等覆盖写入） */
    [300, 900].forEach(function (delay) {
      window.setTimeout(schedule, delay);
    });
  });
  document.addEventListener('shopify:section:load', observeGrid);
})();
